import { getDefaultItem, getItemObjFromAPI } from './items';
import { getDefaultClue, getClueObjFromAPI } from './clues';
import { getProviderObjFromAPI, getDefaultProvider } from './providers';

let routeStop = {
  providerId: '',
  itemId: '',
  itemName: '',
  clueId: '',
  clueName: '',
  action: '',
};

const getDefaultRouteStop = () => {
  return {
    routeStopId: 0,
    providerId: '',
    provider: getDefaultProvider(),
    itemId: '',
    item: getDefaultItem(),
    itemName: '',
    clueId: '',
    clue: getDefaultClue(),
    clueName: '',
    action: '',
  };
};

const getRouteStopObjFromAPI = (routeStopFromAPI) => {
  let r = getDefaultRouteStop();
  //TODO: IMPLEMENT MORE FIELDS AS YOU PROGRESS
  r.id = routeStopFromAPI.id;
  r.itemId = routeStopFromAPI.itemId;
  if (routeStopFromAPI.item) r.item = getItemObjFromAPI(routeStopFromAPI.item);
  r.clueId = routeStopFromAPI.clueId;
  if (routeStopFromAPI.clue) r.clue = getClueObjFromAPI(routeStopFromAPI.clue);
  r.action = routeStopFromAPI.action;
  return r;
};

const getRouteStopCollFromAPI = (stopsFromAPI) => {
  let objRouteStopColl = [];
  stopsFromAPI.forEach((s) => {
    let objRouteStop = getDefaultRouteStop();
    objRouteStop.clueId = s.clueId;
    if (s.clue) objRouteStop.clue = getClueObjFromAPI(s.clue);
    objRouteStop.providerId = s.providerId;
    if (s.provider) objRouteStop.provider = getProviderObjFromAPI(s.provider);
    objRouteStop.itemId = s.itemId;
    if (s.item) objRouteStop.item = getItemObjFromAPI(s.item);
    objRouteStop.action = s.action;
    objRouteStopColl.push(objRouteStop);
  });
  return objRouteStopColl;
};

export { routeStop, getRouteStopCollFromAPI, getRouteStopObjFromAPI, getDefaultRouteStop };
